import createFieldArray from './createFieldArray';
import plain from './structure/plain';
export default createFieldArray(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/FieldArray.js
// module id = tXCH
// module chunks = 1